var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",class:{ 'is-fallback': _vm.isFallback },style:(_vm.boxStyle)},[(!_vm.isFallback)?_c('img',{staticClass:"avatar-img",attrs:{"src":_vm.src},on:{"error":_vm.onError}}):_c('span',{staticClass:"avatar-char"},[_vm._v(_vm._s(_vm.fallbackChar))])])
}
var staticRenderFns = []

export { render, staticRenderFns }